import { Button } from '@/components/ui/button'
import { ExcludeCellIcon } from '@/icons/ExcludeCellIcon'
import { IncludeCellIcon } from '@/icons/IncludeCellIcon'
import { toggleTool } from '@/redux/store/slices/map/mapSlice'
import { useAppDispatch } from '@redux/hooks/useAppState'
import { EXCLUSION_TOOL } from 'honeygrid-types'

import type { MapTool } from 'honeygrid-types'

interface MapToolButtonProps {
	selected: boolean
	tool: NonNullable<MapTool>
}

export const MapToolButton = ({ selected, tool }: MapToolButtonProps) => {
	const dispatch = useAppDispatch()
	const Icon = tool === EXCLUSION_TOOL ? ExcludeCellIcon : IncludeCellIcon

	return (
		<Button
			onClick={() => dispatch(toggleTool(tool))}
			size="mapTool"
			variant={selected ? 'default' : 'secondary'}
			className="cursor-pointer"
		>
			<Icon />
		</Button>
	)
}
